import React from "react";
const HeaderLower = () => {
  return (
    <div className="header_lower">Try a Purple & Enter to Win a Vacation!</div>
  );
};
export default HeaderLower;
